exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-column{flex-direction:column}.status-column .status-text{margin-top:.25rem}.status-text{color:var(--text-light);font-style:italic;font-weight:lighter;text-transform:capitalize}.status-text::before{content:\"\";display:inline-block;height:10px;width:10px;margin-right:.375rem;border-radius:50%}.status-text.success::before{background-color:var(--status-success)}.status-text.error::before{background-color:var(--status-error)}.status-text.warn::before{background-color:var(--status-warn)}.status-text.disabled::before{background-color:var(--status-disabled)}.status-text.special::before{background-color:var(--boy-blue)}", ""]);

// exports
